// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiRequest from "lumi-rescript/lib/es6/src/LumiRequest.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as LumiReactReducer from "lumi-rescript/lib/es6/src/LumiReactReducer.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as API$LumiAuthentication from "./API.res.js";
import * as Form$LumiAuthentication from "./Form.res.js";
import * as I18n$LumiAuthentication from "./I18n.res.js";
import * as Modal$LumiAuthentication from "./Modal.res.js";
import * as Validate$LumiAuthentication from "./Validate.res.js";

function PasswordLogin$LoginForm(props) {
  let dispatch = props.dispatch;
  let samlRequestUrl = props.samlRequestUrl;
  let passwordTxt = props.passwordTxt;
  let emailTxt = props.emailTxt;
  let emailValid = Validate$LumiAuthentication.email(emailTxt);
  let passwordValid = Validate$LumiAuthentication.existingPassword(passwordTxt);
  let samlEnabled = samlRequestUrl !== undefined;
  let submitLabel = samlEnabled ? ({
      TAG: "CommonEntry",
      _0: {
        TAG: "LogInWith",
        _0: Stdlib_Option.getOr(props.identityProviderName, "SAML")
      }
    }) : ({
      TAG: "CommonEntry",
      _0: "LogIn"
    });
  return JsxRuntime.jsxs(Modal$LumiAuthentication.Form.make, {
    title: {
      TAG: "CommonEntry",
      _0: "LogIn"
    },
    onSubmit: param => dispatch("PerformLogin"),
    children: [
      JsxRuntime.jsxs("section", {
        children: [
          JsxRuntime.jsx(Form$LumiAuthentication.$$Error.make, {
            error: props.lastError
          }),
          JsxRuntime.jsx(Form$LumiAuthentication.EmailField.make, {
            value: emailTxt,
            valid: emailValid,
            onChange: txt => dispatch({
              TAG: "UpdateEmailTxt",
              _0: txt
            })
          }),
          JsxRuntime.jsx(Form$LumiAuthentication.ExistingPasswordField.make, {
            value: passwordTxt,
            valid: passwordValid,
            enabled: !samlEnabled,
            onChange: txt => dispatch({
              TAG: "UpdatePasswordTxt",
              _0: txt
            })
          })
        ],
        className: "modal-card-body"
      }),
      JsxRuntime.jsx("footer", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("p", {
              children: JsxRuntime.jsx("button", {
                children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
                  entry: "PhrasePasswordForgotten"
                }),
                className: "button",
                disabled: samlEnabled,
                type: "button",
                onClick: param => dispatch("ForgotPassword")
              }),
              className: "control"
            }),
            JsxRuntime.jsx("p", {
              children: samlRequestUrl !== undefined ? JsxRuntime.jsx("a", {
                  children: JsxRuntime.jsx(I18n$LumiAuthentication.T.Text.make, {
                    entry: submitLabel
                  }),
                  className: "button is-success",
                  href: samlRequestUrl
                }) : JsxRuntime.jsx(Form$LumiAuthentication.Submit.make, {
                  classList: [
                    [
                      "button",
                      true
                    ],
                    [
                      "is-success",
                      true
                    ]
                  ],
                  enabled: emailValid && passwordValid,
                  label: submitLabel
                }),
              className: "control"
            })
          ],
          className: "field is-grouped is-grouped-right is-flex-1"
        }),
        className: "modal-card-foot"
      })
    ]
  });
}

let LoginForm = {
  make: PasswordLogin$LoginForm
};

function PasswordLogin(props) {
  let toParent = props.toParent;
  let initialError = props.initialError;
  let initialEmail = props.initialEmail;
  let match = LumiReactReducer.useReducer(() => ({
    TAG: "Init",
    _0: {
      emailTxt: initialEmail,
      passwordTxt: "",
      lastError: initialError,
      identityProviderName: undefined,
      samlRequestUrl: undefined
    }
  }), undefined, (state, action) => {
    if (typeof action !== "object") {
      if (action === "PerformLogin") {
        return {
          TAG: "Effect",
          _0: param => {
            let dispatch = param.dispatch;
            let match = param.state;
            return LumiRequest.resultFutureEffect(API$LumiAuthentication.cookieLoginPassword(match.emailTxt, match.passwordTxt), accountDoc => dispatch({
              TAG: "LoginSucceeded",
              _0: accountDoc
            }), err => dispatch({
              TAG: "LoginFailed",
              _0: err
            }));
          }
        };
      } else {
        return {
          TAG: "Effect",
          _0: param => {
            toParent({
              TAG: "ShowPasswordForgotten",
              initialEmail: param.state.emailTxt,
              initialError: undefined
            });
          }
        };
      }
    }
    switch (action.TAG) {
      case "UpdateEmailTxt" :
        let updatedEmail = action._0;
        let newState_passwordTxt = state.passwordTxt;
        let newState_lastError = state.lastError;
        let newState = {
          emailTxt: updatedEmail,
          passwordTxt: newState_passwordTxt,
          lastError: newState_lastError,
          identityProviderName: undefined,
          samlRequestUrl: undefined
        };
        if (Validate$LumiAuthentication.email(updatedEmail)) {
          return {
            TAG: "UpdateWithEffect",
            _0: newState,
            _1: param => {
              let dispatch = param.dispatch;
              return LumiRequest.resultFutureEffect(API$LumiAuthentication.getSamlRequestData(updatedEmail, undefined), samlRequestData => dispatch({
                TAG: "UpdateSamlRequestData",
                _0: samlRequestData
              }), _err => {});
            }
          };
        } else {
          return {
            TAG: "Update",
            _0: newState
          };
        }
      case "UpdatePasswordTxt" :
        return {
          TAG: "Update",
          _0: {
            emailTxt: state.emailTxt,
            passwordTxt: action._0,
            lastError: state.lastError,
            identityProviderName: state.identityProviderName,
            samlRequestUrl: state.samlRequestUrl
          }
        };
      case "UpdateSamlRequestData" :
        let match = action._0;
        if (match.forEmailAddress === state.emailTxt) {
          return {
            TAG: "Update",
            _0: {
              emailTxt: state.emailTxt,
              passwordTxt: state.passwordTxt,
              lastError: state.lastError,
              identityProviderName: match.identityProviderName,
              samlRequestUrl: match.samlRequestUrl
            }
          };
        } else {
          return {
            TAG: "Update",
            _0: {
              emailTxt: state.emailTxt,
              passwordTxt: state.passwordTxt,
              lastError: state.lastError,
              identityProviderName: undefined,
              samlRequestUrl: undefined
            }
          };
        }
      case "LoginSucceeded" :
        let account = action._0;
        return {
          TAG: "Effect",
          _0: param => {
            toParent({
              TAG: "Authenticated",
              _0: account
            });
          }
        };
      case "LoginFailed" :
        let error = action._0;
        console.error("Password login failed from state", state, "with error", error);
        return {
          TAG: "Update",
          _0: {
            emailTxt: state.emailTxt,
            passwordTxt: state.passwordTxt,
            lastError: I18n$LumiAuthentication.entryFromApiError(error),
            identityProviderName: state.identityProviderName,
            samlRequestUrl: state.samlRequestUrl
          }
        };
    }
  });
  let match$1 = match[0];
  return JsxRuntime.jsx(PasswordLogin$LoginForm, {
    emailTxt: match$1.emailTxt,
    passwordTxt: match$1.passwordTxt,
    lastError: match$1.lastError,
    identityProviderName: match$1.identityProviderName,
    samlRequestUrl: match$1.samlRequestUrl,
    dispatch: match[1]
  });
}

let T;

let make = PasswordLogin;

export {
  T,
  LoginForm,
  make,
}
/* LumiRequest Not a pure module */
